import { Github, ExternalLink } from "lucide-react";
import { fmtMonth } from "../lib/format";
import { EditableText } from "./EditableText";

const STATUS_STYLES = {
  published: "bg-emerald-500/20 text-emerald-400",
  in_progress: "bg-amber-500/20 text-amber-400",
  draft: "bg-white/10 text-dim",
};

export function StatusBadge({ status, editable = false }) {
  const label = status === "in_progress" ? "IN PROGRESS" : (status || "").toUpperCase();
  return (
    <span className={`font-mono text-[10px] px-2 py-0.5 rounded font-bold ${STATUS_STYLES[status] || STATUS_STYLES.draft}`} data-testid={`status-badge-${status}`}>
      {editable && status === "published" ? (
        <EditableText k="project_status_published" defaultValue="PUBLISHED" />
      ) : (
        label
      )}
    </span>
  );
}

export function ProjectCard({ project }) {
  return (
    <article
      className="p-6 rounded-xl bg-panel border border-white/10 flex flex-col justify-between hover:border-cyber transition-colors"
      data-testid={`project-card-${project.id}`}
    >
      <div>
        <div className="flex items-center justify-between mb-4">
          <StatusBadge status={project.status} editable />
          <span className="font-mono text-xs text-dim">{fmtMonth(project.date)}</span>
        </div>
        <h3 className="font-display text-lg text-white font-bold mb-2">{project.title}</h3>
        <p className="text-xs text-dim leading-relaxed mb-4">{project.description}</p>
      </div>
      <div>
        {project.image_url && (
          <figure className="relative aspect-[16/9] bg-deep rounded border border-white/5 overflow-hidden mb-4">
            <img src={project.image_url} alt={project.title} className="w-full h-full object-cover opacity-80" loading="lazy" />
          </figure>
        )}
        <div className="flex items-center justify-between gap-3">
          <div className="font-mono text-[11px] text-cyber">
            {(project.tech || []).join(" • ")}
          </div>
          <div className="flex items-center gap-2">
            {project.github_url && (
              <a href={project.github_url} target="_blank" rel="noopener noreferrer" aria-label="GitHub repository"
                className="text-dim hover:text-cyber transition-colors" data-testid={`project-github-link-${project.id}`}>
                <Github className="w-4 h-4" />
              </a>
            )}
            {project.demo_url && (
              <a href={project.demo_url} target="_blank" rel="noopener noreferrer" aria-label="Live demo"
                className="text-dim hover:text-cyber transition-colors" data-testid={`project-demo-link-${project.id}`}>
                <ExternalLink className="w-4 h-4" />
              </a>
            )}
          </div>
        </div>
      </div>
    </article>
  );
}
